module.exports = __webpack_public_path__ + "img/staff.d957a423.svg";